// Author Liu Cui Cui
// Date 2022-07-19 18:33:15

import * as model from "@/model/sithMes/tpm/SithMesTpmAxisDataTadModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesTpmAxisDataTad(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_TPM_URL,
    })
    .buildStore()
